import { OnInit } from '@angular/core';
import { DacConfig } from '../shared/services/dac-config.service';
var HelpComponent = /** @class */ (function () {
    function HelpComponent(dacConfig) {
        this.dacConfig = dacConfig;
    }
    HelpComponent.prototype.ngOnInit = function () {
    };
    Object.defineProperty(HelpComponent.prototype, "supportEmail", {
        get: function () {
            return this.dacConfig.supportEmail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HelpComponent.prototype, "supportPhone", {
        get: function () {
            return this.dacConfig.supportPhone;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HelpComponent.prototype, "copyrightTitle", {
        get: function () {
            return this.dacConfig.copyrightTitle;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HelpComponent.prototype, "mailLink", {
        get: function () {
            return "mailto:" + this.supportEmail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HelpComponent.prototype, "phoneLink", {
        get: function () {
            return "tel:" + this.supportPhone;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HelpComponent.prototype, "copyrightURL", {
        get: function () {
            return this.dacConfig.copyrightURL;
        },
        enumerable: true,
        configurable: true
    });
    return HelpComponent;
}());
export { HelpComponent };



// WEBPACK FOOTER //
// ./src/app/help/help.component.ts.pre-build-optimizer.js